import { BlogArticle } from "@/app/types/BlogArticle";
import { BlogArticleLocale } from "@/app/types/BlogArticleContent";
import { BlogCategory } from "@/app/types/BlogCategory";
import { callRecordingGdprArticle } from "../../content/CallRecordingGdprArticle";
import { callToolsArticle } from "../../content/CallToolsArticle";
import { demoCallArticle } from "../../content/DemoCallArticle";
import { discoveryCallArticle } from "../../content/DiscoveryCallArticle";
import { freeCallAnalysisArticle } from "../../content/FreeCallAnalysisArticle";
import { leexiPricingArticle } from "../../content/LeexiPricingArticle";
import { mcpSalesCallsArticle } from "../../content/McpSalesCallsArticle";
import { modjoAlternativesArticle } from "../../content/ModjoAlternativesArticle";
import { objectionHandlingArticle } from "../../content/ObjectionHandlingArticle";
import { realtimeAnalysisArticle } from "../../content/RealtimeAnalysisArticle";
import { salesCsHandoverArticle } from "../../content/SalesCsHandoverArticle";
import { salesKnowledgeBaseArticle } from "../../content/SalesKnowledgeBaseArticle";
import { smallTeamCallAnalysisArticle } from "../../content/SmallTeamCallAnalysisArticle";
import { winLossAnalysisArticle } from "../../content/WinLossAnalysisArticle";

export const BLOG_ARTICLES: BlogArticle[] = [
  winLossAnalysisArticle,
  salesKnowledgeBaseArticle,
  objectionHandlingArticle,
  salesCsHandoverArticle,
  mcpSalesCallsArticle,
  demoCallArticle,
  realtimeAnalysisArticle,
  callRecordingGdprArticle,
  smallTeamCallAnalysisArticle,
  discoveryCallArticle,
  leexiPricingArticle,
  freeCallAnalysisArticle,
  modjoAlternativesArticle,
  callToolsArticle,
];

export const CATEGORY_IDS_WITH_ARTICLES = new Set<BlogCategory>(
  BLOG_ARTICLES.map((article) => article.categoryId),
);

export function findArticleBySlug(lang: string, slug: string): BlogArticle | undefined {
  return BLOG_ARTICLES.find((article) => article.slug[lang] === slug);
}

export function getArticleLocale(article: BlogArticle, lang: string): BlogArticleLocale {
  return article.locales[lang] ?? article.locales.fr;
}

export function articleSeed(article: BlogArticle): number {
  return Math.max(0, BLOG_ARTICLES.indexOf(article));
}

export function formatCardDate(value: string, lang: string): string {
  return new Intl.DateTimeFormat(lang, {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(value));
}

export function getRelatedArticles(article: BlogArticle, count: number): BlogArticle[] {
  const others = BLOG_ARTICLES.filter((item) => item.key !== article.key);
  const sameCategory = others.filter((item) => item.categoryId === article.categoryId);
  const rest = others.filter((item) => item.categoryId !== article.categoryId);

  return [...sameCategory, ...rest].slice(0, count);
}
